import { Box } from "@mui/material";
import { useParams } from "react-router-dom";

import { ErrorState } from "src/components/atoms/ErrorState";
import { ScrollContainer } from "src/components/containers/ScrollContainer";
import { LoadingCard } from "src/components/molecules/Loading";
import { ProposalsWithStats } from "src/components/organisms/ProposalsWithStats/ProposalsWithStats";
import { VotingStatsBreakdown } from "src/components/organisms/VotingStatsBreakdown/VotingStatsBreakdown";
import { VotingTrendStats } from "src/components/organisms/VotingTrendStats";
import { useProxyEventQuery } from "src/store/proxyEvent";

export function ProxyEventVotingTab() {
  const { id } = useParams() as { id: string };
  const { data: proxyEvent, isLoading, error } = useProxyEventQuery({ id });

  if (error || (!isLoading && !proxyEvent)) {
    return <ErrorState />;
  }

  if (isLoading) {
    return (
      <ScrollContainer sx={{ pb: 10, pl: 10, pr: 6.25 }}>
        <Box sx={{ mt: 8 }}>
          <LoadingCard />
        </Box>
        <Box sx={{ mt: 8 }}>
          <LoadingCard />
        </Box>
        <Box sx={{ mt: 8 }}>
          <LoadingCard />
        </Box>
      </ScrollContainer>
    );
  }

  return (
    <ScrollContainer sx={{ pb: 10, pl: 10, pr: 6.25 }}>
      <Box sx={{ mt: 8 }}>
        <VotingTrendStats />
      </Box>
      <Box sx={{ mt: 8 }}>
        <VotingStatsBreakdown stats={proxyEvent.stats} />
      </Box>
      <Box sx={{ mt: 8 }}>
        <ProposalsWithStats />
      </Box>
    </ScrollContainer>
  );
}
